<template lang="pug">
  v-container(fluid fill-height class="ma-0 pa-0")
    v-img(height="100%" width="100%")
      l-map(
      v-if="showMap"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: 89vh"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate",
      @click="mapclick",
      ref="myMap"
      :maxZoom="19"
      :minZoom="5"
    )
        l-tile-layer(:url="url" :attribution="attribution" :options="layerOptions" :tile-layer-class="tileLayerClass")
        l-marker-cluster(":options"="{disableClusteringAtZoom: 9}" ref="radarCluster")
          l-marker(v-for="m in radarMarkers" :key="m.ID" :lat-lng="m.LatLng" :icon="getIcon(m)" ref="markers" @update:visible="updateMarker")
            l-popup(style="padding:10px;")
              charger-popup(:car="car" :marker="m" :settings="settings" :canCenter="true" @centerRadar="centerRadar")
        l-marker-cluster(":options"="{disableClusteringAtZoom: 9}")
          l-marker(v-for="m in routeMarkers" :key="m.ID" :lat-lng="m.LatLng" :icon="getIcon(m)")
            l-popup
              charger-popup(:car="car" :marker="m" :settings="settings")  
        l-marker(v-if="homeLocation != null" :lat-lng="homeLocation" :zIndexOffset="100" :duration="1000" :icon="getHomeIcon()")  
        l-polyline(v-for="trip in trips" :key="trip.id" ":lat-lngs"="trip.path" :color="colourForTrip(trip.id)")
        #l-polyline(v-for="p in spiderweb" :key="p.id" ":lat-lngs"="p.path" :color="colourForConsumption(p.EnergyPercent)" :opacity="0.2")
        l-polygon(:lat-lngs="splat" fillColor="green" :smoothFactor="5" :stroke="false")
</template>

<script>
import MapSupport from "../mixins/MapSupport.js";
import L from "leaflet";
export default {
    mixins:[MapSupport],
  name: "Map",
  props: ["radarMarkers", "routeMarkers",  "homeAddress", "trips", "car", "settings","spiderweb", "splat"],

  computed: {
    homeLocation() {
      if (this.homeAddress.Address != null) {
        return L.latLng(
          this.homeAddress.Address.geometry.coordinates[1],
          this.homeAddress.Address.geometry.coordinates[0]
        );
      } else {
        return null;
      }
    }
  },
  mounted() {
      setTimeout(this.updatePaths,500);
  },
  methods: {
    updateMarker(m) {
      console.log(m);
      setTimeout(this.updatePaths,500);
    },
    getMarkerBounds() {
      let latlngs = [];
      for (var i = 0; i < this.radarMarkers.length; i++) {
        let r = this.radarMarkers[i];
        latlngs.push(L.latLng(r.LatLng.lat,r.LatLng.lng))
      }
      return latlngs;
    },
    centerRadar(m) {
      this.$emit("centerRadar",m);
            setTimeout(this.updatePaths,500);
    },
    zoomUpdate() {
      setTimeout(this.updatePaths,500);
    },
    updatePaths() {
    // this.$emit("mapUpdate");
    },
    fitMarkerBounds() {
      let latlngs = this.getMarkerBounds();
      if (latlngs.length > 0) {
        this.$refs.myMap.mapObject.fitBounds(latlngs)
      }
    },
    centerMap(latlng) {
       this.$refs.myMap.mapObject.panTo(new L.latLng(latlng.lat, latlng.lng));
    }
  },
  watch: {
    "car.Range": function() {
      setTimeout(this.updatePaths,500);
    },
  }
};
</script>
<style scoped>

@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

</style>